import api from '../irelandApi';
import {
  GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_FULFILLED,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_PENDING,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_REJECTED,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_PENDING,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_FULFILLED,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_REJECTED,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_PENDING,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_FULFILLED,
  GET_PIP_EPOS_DATA_MISSING_WEEKS_REJECTED,
  PATCH_RESET_STRIKE_COUNTER_PENDING,
  PATCH_RESET_STRIKE_COUNTER_FULFILLED,
  PATCH_RESET_STRIKE_COUNTER_REJECTED
} from '../reducers/pipEposDataMissingWeekReducer';

export const getOutlets = () => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_PENDING });

  return api.get('/api/pip_epos_data_missing_weeks/outlets')
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_REJECTED,
        payload: error.response
      });
    });
};

export const getPostcodeplanObjectives = outletId => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_PENDING });

  return api.get(`/api/pip_epos_data_missing_weeks/${outletId}/postcodeplan_objectives`)
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_REJECTED,
        payload: error.response
      });
    });
};

export const getPipEposDataMissingWeeks = () => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_DATA_MISSING_WEEKS_PENDING });

  return api.get('/api/admin/pip_epos_data_missing_weeks/by_outlet')
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_DATA_MISSING_WEEKS_REJECTED,
        payload: error.response.data
      });
    });
};

export const patchResetStrikeCounter = customerNumber => (dispatch) => {
  dispatch({ type: PATCH_RESET_STRIKE_COUNTER_PENDING });

  const params = {
    pip_epos_data_missing_weeks: { customer_number: customerNumber }
  };

  return api.patch('/api/admin/pip_epos_data_missing_weeks/reset_strike_counter', params)
    .then((response) => {
      dispatch({
        type: PATCH_RESET_STRIKE_COUNTER_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: PATCH_RESET_STRIKE_COUNTER_REJECTED,
        payload: error.response.data
      });
    });
};
